import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import ActionNotifications from "../../Components/ActionNotifications";
import useFetch from "../../Hooks/useFetch";
import ProgressBar from "./Components/progressBar";
import InfoTab from "./Components/infoTab";
import { getUserId } from "../../Utils/helper";
import { Button } from "devextreme-react/button";

import DenyPurchaseOrders from "../../Components/DenyOrders/denyPurchaseOrders";
import ActionNeededPurchaseOrders from "../../Components/ActionNeededPO";
import ActionProvidedPurchaseOrders from "../../Components/ActionProvidedPO";

function Details(props) {
  console.log("props", props);
  const navigate = useNavigate();
  const fetch = useFetch(navigate);

  const poDetail = props?.data?.data;
  const [response, setResponse] = useState([]);
  const isUserKristen = getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da";

  const [showPopup, setPopup] = useState({
    poActionNeeded: null,
    poActionProvided: null,
  });

  const handleClose = (popupKey) => {
    setPopup((prev) => ({ ...prev, [popupKey]: null }));
  };

  const handlePopup = useCallback((popupKey, data) => {
    setPopup((prev) => ({ ...prev, [popupKey]: { data } }));
  }, []);

  const fetchSuccessful = (resp) => {
    setResponse(resp);
    return (
      resp?.success &&
      resp?.data?.statusCode &&
      resp?.success !== "Invalid Model"
    );
  };

  return (
    <>
      <ActionNotifications response={response} />

      {showPopup.poActionNeeded && (
        <ActionNeededPurchaseOrders
          orderId={showPopup.poActionNeeded.data}
          setNotifications={(n) => setResponse(n)}
          onClose={() => handleClose("poActionNeeded")}
          mutate={props?.mutate}
          fetch={fetch}
        />
      )}
      {showPopup.poActionProvided && (
        <ActionProvidedPurchaseOrders
          orderId={showPopup.poActionProvided.data}
          setNotifications={(n) => setResponse(n)}
          onClose={() => handleClose("poActionProvided")}
          mutate={props?.mutate}
          fetch={fetch}
        />
      )}
      {/* Action needed button right above ProgressBar */}
      <div className="div-button div-button-action">
        <Button
          id="action-needed-button"
          type="normal"
          text="Request Action"
          onClick={() => handlePopup("poActionNeeded", poDetail?.id)}
          visible={
            (poDetail?.poStatus < 4 || poDetail?.poStatus === 11) &&
            poDetail?.poStatus !== 10 &&
            isUserKristen
          }
        />
      </div>
      {/* Action Provided button right above ProgressBar */}
      <div className="div-button div-button-action">
        <Button
          id="action-provided-button"
          type="normal"
          text="Send for Review"
          onClick={() => handlePopup("poActionProvided", poDetail?.id)}
          visible={poDetail?.poStatus === 10}
        />
      </div>

      <ProgressBar
        type={"PO"}
        order={poDetail}
        fetch={fetch}
        fetchSuccessful={fetchSuccessful}
      />

      <InfoTab
        poDetail={poDetail}
        isUserKristen={isUserKristen}
        fetchSuccessful={fetchSuccessful}
      />
    </>
  );
}

export default Details;
